import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// whether the user may edit / delete a problem
const useProblemPermission = () => {
  const permissions = useSelector((state) => state.auth.permissions);
  const [permittedToEdit, setPermittedToEdit] = useState(false);

  useEffect(() => {
    updatePermittedToEdit();
  }, [permissions]);

  const updatePermittedToEdit = () => {
    // authorize to permit edit
    let _permittedToEdit = false;
    if (
      permissions &&
      (permissions.includes("view it") ||
        permissions.includes("update kabag-transport") ||
        permissions.includes("update pnj-transport") ||
        permissions.includes("update pnj") ||
        permissions.includes("update adm-transport"))
    ) {
      _permittedToEdit = true;
    }
    setPermittedToEdit(_permittedToEdit);
  };

  return { permittedToEdit };
};

export default useProblemPermission;
